import { MvcContainer } from './mvc-container';

export class Controller extends MvcContainer {

}
